// src/components/Menu.js
import { Link, useLocation } from "react-router-dom";
import "./Menu.css";

export default function Menu() {
  const location = useLocation();

  return (
    <nav className="menu-bar">
      <Link to="/" className={location.pathname === "/" ? "active" : ""}>
        Comerciantes
      </Link>
      <Link to="/busqueda" className={location.pathname === "/busqueda" ? "active" : ""}>
        Búsqueda
      </Link>
      <Link to="/meili/sinonimos" className={location.pathname === "/meili/sinonimos" ? "active" : ""}>
        Sinónimos
      </Link>
      <Link to="/meili/diagnostico" className={location.pathname === "/meili/diagnostico" ? "active" : ""}>
        Meili (Diag)
      </Link>
      <Link to="/auditoria" className={location.pathname === "/auditoria" ? "active" : ""}>
        Auditoría Chat
      </Link>
      <Link to="/solicitudes" className={location.pathname === "/solicitudes" ? "active" : ""}>
        Solicitudes
      </Link>
      <Link to="/unidades" className={location.pathname === "/unidades" ? "active" : ""}>
        Unidades de Venta
      </Link>
      <Link to="/login" className={location.pathname === "/login" ? "active" : ""}>
        Cerrar sesión
      </Link>

    </nav>
  );
}
